import Qs from 'qs'
import request from './request'

/**
 * 封装 POST 请求（兼容旧代码风格）
 * @param {string} url - API 路径
 * @param {object} data - 请求数据
 * @returns {Promise}
 */
export function post(url, data = {}) {
  return request({
    url,
    method: 'post',
    transformRequest: [function (d) {
      return Qs.stringify(d)
    }],
    data
  })
}

/**
 * 封装 GET 请求
 * @param {string} url - API 路径
 * @param {object} params - 查询参数
 * @returns {Promise}
 */
export function get(url, params = {}) {
  return request({
    url,
    method: 'get',
    params
  })
}

export { request, Qs }
